export const ERROR = 'ERROR';
export const DATA_NOT_FOUND = 'DATA_NOT_FOUND';
export const EXPIRED = 'EXPIRED';
